import { gql } from '@apollo/client';

export const DEL_PROPERTY_OF_THE_WEEK_MUTATION = gql`
  mutation delHighLighted($input: InputPropertyHighLighted!) {
    deletePropertyHighLighted(input: $input)
  }
`;
